export enum ContractStatus {
  NotDefined = -1,
  Pending = 0,
  Active = 1,
  Rejected = 2,
  Cancelled = 3,
}
